import React from 'react';
import { View, StyleSheet, Text, ScrollView } from 'react-native';

import { Card, Divider } from '@rneui/themed';

import { branchComponent } from '../../utils/Utils';
import {
    type ColumnInfoType,
    type ColumnInfoValueType,
} from '../../types/ColumnInfo';

const styles = StyleSheet.create({
    container: {
        width: '100%',
        padding: 10,
        backgroundColor: '#fff',
        alignItems: 'center',
        justifyContent: 'center',
    },
    cardContainer: {
        flex: 1,
    },
    horizontal: {
        marginBottom: 10,
    },
    horizontalContainer: {
        flexDirection: 'row',
        width: '100%',
    },
    horizontalText: {
        textAlign: 'left',
        fontSize: 16,
        marginVertical: 10,
        width: '50%',
    },
    horizontalValue: {
        marginVertical: 10,
        width: '70%',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

interface DialogProps {
    data: ColumnInfoType;
    title: string;
}

const Dialog: React.FC<DialogProps> = ({ data, title }) => {
    return (
        <View style={styles.container}>
            <Card>
                <Card.Title>{title}</Card.Title>
                <Card.Divider />
                <View style={styles.horizontal}>
                    {data !== null ? (
                        <ScrollView>
                            {Object.keys(data).map((key, index) => {
                                const value: ColumnInfoValueType = data[key];
                                if (value.type !== 'hidden') {
                                    return (
                                        <React.Fragment key={index}>
                                            <View
                                                style={
                                                    styles.horizontalContainer
                                                }
                                            >
                                                <Text
                                                    style={
                                                        styles.horizontalText
                                                    }
                                                >
                                                    {value.name}:{' '}
                                                </Text>
                                                <>
                                                    {branchComponent(
                                                        key,
                                                        value
                                                    )}
                                                </>
                                            </View>
                                            <Divider
                                                inset={true}
                                                insetType="right"
                                            />
                                        </React.Fragment>
                                    );
                                }
                            })}
                        </ScrollView>
                    ) : (
                        <></>
                    )}
                </View>
            </Card>
        </View>
    );
};

export default Dialog;
